export default __webpack_public_path__ + "static/media/mario1.632c25df.jpg";